<template>
	<div class="setting-layout">
		<ms-dropdown
			:width="300"
			overflow="unset"
			ref="layoutDropdown"
			@close="closeDropdown"
		>
			<template slot="icon">
				<div
					class="mi mi-20 mi-layout-setting ml-3"
					v-tooltip="{
						content: $t('i18nCommon.ConfigLayout'),
						placement: 'bottom-end',
					}"
				></div>
			</template>
			<div class="dropdown-menu-layout flex-box">
				<div class="filter-layout">
					<ms-input
						:placeholder="$t('i18nCommon.InputSearch')"
						icon="mi-icon-search"
						v-model="searchValue"
						@change="changeSearch"
					></ms-input>
				</div>
				<div class="list-coloumn-layout flex-1">
					<div class="flex">
						<div class="item-select w-full flex" v-if="!searchValue">
							<ms-checkbox
								:title="$t('i18nTaxPaper.List.All')"
								class="checkbox-item"
								:value="isCheckedMultiple"
								@click="changeCheckedMultiple"
							></ms-checkbox>
						</div>
					</div>
					<draggable group="div" :list="columns" handle=".draggable-icon">
						<div
							v-for="col in columnx"
							class="flex"
							:key="col.dataField"
							@mouseover="colHoverx = col"
						>
							<div
								class="item-select w-full he-full flex"
								v-if="col.isConfig != false"
							>
								<ms-checkbox
									:title="col.title"
									class="checkbox-item"
									v-model="col.visiable"
								></ms-checkbox>
								<div
									class="draggable-icon mi mi-16 mi-draggable-icon"
									v-show="!searchValue && colHoverx == col"
								></div>
							</div>
						</div>
					</draggable>
					<div class="text-center pt-4 pb-4" v-if="columnx.length == 0">
						{{ $t('i18nCommon.NoDataFilter') }}
					</div>
				</div>
				<div class="toolbar-action">
					<ms-button
						:title="$t('i18nCommon.SetDefault')"
						v-if="columnx.length != 0"
						class="btn-size"
						type="third"
						@click="resetBackToDefaultLayout"
					></ms-button>
					<ms-button
						:title="$t('i18nTaxPaper.List.Cancel')"
						v-if="columnx.length != 0"
						class="btn-size"
						type="third-white"
						@click="cancel"
					></ms-button>
					<ms-button
						:title="$t('i18nTaxPaper.List.Accept')"
						class="btn-size ml-2"
						v-if="columnx.length != 0"
						@click="applyLayout"
					></ms-button>
				</div>
			</div>
		</ms-dropdown>
	</div>
</template>
<script>
import draggable from 'vuedraggable';
import { mapState, mapActions, mapGetters } from 'vuex';
import {
	ModuleLayout,
	ModuleAuth,
	ModuleCompany,
} from '../../store/module-const';
import ColumnModel from '@/model/ColumnModel.js';
export default {
	name: 'msConfigLayout',
	components: {
		draggable,
	},
	props: {
		//Cấu hình các cột truyền vào
		/**
		 * Các thuộc tính trong columns
		 * @params dataField Field dữ liệu dùng để nhận giá trị thay đổi và hiện thị.
		 * @params title:Tiêu đề của cột
		 * @params width:độ rộng của cột
		 * @params autoResize:Cột tự động to ra khi màn hình lớn
		 * @params formatType:Dữ liệu dùng để format lấy từ trong file enumeration.js FormatType
		 */
		columns: {
			default: () => [],
		},
		customLayout: {},
		LayoutID: {
			default: null,
			type: String,
		},
		autoResizeList: {
			default: () => [],
		},
	},
	mounted() {
		const me = this;
		me.loadLayoutConfig();
	},
	data() {
		return {
			searchValue: null,
			columnx: [],
			colHoverx: null,
			index: 0,
		};
	},
	computed: {
		...mapGetters(ModuleAuth, ['userInfo']),
		...mapGetters(ModuleCompany, ['companyInfo']),
		//Kiểm tra layout checkbox check tất cả
		//Created by LTDAT (04.08.2020)
		isCheckedMultiple() {
			const me = this;
			let itemCheck = me.columns.filter((item) => {
				return item.visiable == true;
			});
			return itemCheck.length == me.columns.length;
		},
	},
	methods: {
		...mapActions(ModuleLayout, [
			'loadLayout',
			'insertLayout',
			'resetDefaultLayout',
		]),
		closeDropdown(outSize) {
			const me = this;
			if (outSize) {
				me.applyLayout();
			} else {
				me.columnx = me.oldConfig || [];
				me.searchValue = null;
				me.setColumnLayout(me.columnx);
			}
		},
		changeSearch(value) {
			const me = this;
			if (value) {
				me.columnx = me.columns.filter((item) => {
					return (
						item.title &&
						item.title.toString() &&
						item.title.toString().toLowerCase().contains(value.toLowerCase())
					);
				});
			} else {
				me.columnx = me.columns || [];
			}
		},
		async loadLayoutConfig() {
			const me = this;
			let params = {
					UserID: me.userInfo.MisaId,
					TaxCode: me.companyInfo.TaxCode,
					LayoutID: me.LayoutID,
				},
				res = await me.loadLayout(params);
			let columns = JSON.parse(res.Data.LayoutValue);
			me.setColumnLayout(columns);
		},
		setColumnLayout(columns) {
			const me = this;
			if (columns) {
				me.columnx = columns || [];
				me.oldConfig = JSON.parse(JSON.stringify(me.columnx));
				me.columnx.forEach((item) => {
					me.mappingResizeCol(me.columnx, true);
					if (typeof me.customLayout == 'function') {
						me.customLayout(item, true);
					}
				});
				me.$emit('update:columns', me.columnx);
				me.$emit('apply', me.columnx);
			}
		},
		mappingResizeCol(columns, isAddNew) {
			const me = this;
			columns.forEach((item) => {
				if (isAddNew) {
					if (
						me.autoResizeList &&
						me.autoResizeList.length > 0 &&
						me.autoResizeList.includes(item.dataField)
					) {
						me.$set(item, 'autoResize', true);
					} else {
						delete item.autoResize;
					}
				} else {
					delete item.autoResize;
				}
				delete item._width;
				delete item._minWidth;
			});
		},
		//Sự kiến ấn vào nút Áp dụng trong cấu hình cột
		//Created by LTDAT (04.08.2020)
		async applyLayout() {
			const me = this;
			me.$refs.layoutDropdown.closeDropdownMenu();
			let columns = JSON.parse(JSON.stringify(me.columns));
			if (typeof me.customLayout == 'function') {
				columns.forEach((item, index) => {
					// me.mappingResizeCol(columns, false);
					// me.customLayout(item, false);
					columns[index] = me.setModelColumn(item);
				});
			}
			let payload = {
				UserID: me.userInfo.MisaId,
				TaxCode: me.companyInfo.TaxCode,
				LayoutID: me.LayoutID,
				LayoutValue: JSON.stringify(columns),
			};
			me.insertLayout(payload);
			me.setColumnLayout(columns);
		},
		setModelColumn(col) {
			const me = this;
			col = new ColumnModel(col);
			return col;
		},
		//Sự kiến ấn vào nút tất cả trên form cấu hình cột
		//Created by LTDAT (04.08.2020)
		changeCheckedMultiple() {
			const me = this;
			if (this.isCheckedMultiple) {
				me.columns.forEach((item) => {
					if (item.isConfig != false) {
						item.visiable = false;
					}
				});
			} else {
				me.columns.forEach((item) => {
					item.visiable = true;
				});
			}
		},
		//Sự kiện ấn vào nút hủy bỏ trên thanh cấu hình cột
		//Created by LTDAT (04.08.2020)
		cancel() {
			const me = this;
			me.$refs.layoutDropdown.closeDropdownMenu();
			me.columnx = me.oldConfig || [];
			me.searchValue = null;
			me.setColumnLayout(me.columnx);
		},

		//Sự kiện ấn vào nút Mặc định trên màn hình cấu hình cột
		//Created by NTNHAN (3/12/2020)
		async resetBackToDefaultLayout() {
			const me = this;
			let params = {
					userId: me.userInfo.MisaId,
					layoutId: me.LayoutID,
				},
				res = await me.resetDefaultLayout(params);
			if (res.Success) {
				me.$refs.layoutDropdown.closeDropdownMenu();
				me.loadLayoutConfig();
			}
		},
	},
};
</script>
<style lang="scss" scoped>
@media screen and (max-width: 1366px) {
	@import '@/assets/scss/_sm-variables.scss';
	@import '@/assets/scss/components/ms-config-layout.scss';
}
@media screen and (min-width: 1367px) {
	@import '@/assets/scss/_variables.scss';
	@import '@/assets/scss/components/ms-config-layout.scss';
}
</style>

